module.exports = __webpack_public_path__ + "images/logo-pettit.237e6d19f96a5ef4768806b064ac752f.png";